document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const targetBtn = e.target.closest('a, button, .btn');
    
    if (targetBtn && targetBtn.textContent.trim().toLowerCase().includes('get vip access')) {
      const vipSection = document.querySelector('.isense-vip-section');
      
      if (vipSection) {
        e.preventDefault();
        
        // Block ko 'center' karne se section screen ke beech mein scroll hoga
        vipSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  });
});